import { TextInput } from "@mantine/core";

const TextFieldInput = ({
  id,
  formik,
  ...props
}: {
  id: string;
  formik: any;
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
  placeholder?: any;
  // setValue: any;
}) => {
  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setValue(event.target.value);
  // };

  return (
    <TextInput
      id={id}
      value={formik.values[id] ?? ""}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={!!(formik.touched[id] && formik.errors[id]) && formik.errors[id]}
      {...props}
    />
  );
};

export default TextFieldInput;
